<div class="grant-access-dialog">
  <div class="d-flex justify-content-between align-items-end pb-3 autocomlete-header">
    <div class="access-left-header gap-5">
      <h2 *ngIf="!isRevokeMode" mat-dialog-title class="text-black fw-medium p-0 mb-0">
        {{ 'grantAccessDialog.toDocument' | translate }}
      </h2>
      <h2 *ngIf="isRevokeMode" mat-dialog-title class="text-black fw-medium p-0 mb-0">
        {{ 'grantAccessDialog.toRevokeDocument' | translate }}
      </h2>
    </div>
    <button class="border-0 bg-transparent delete-btn" (click)="onCancel()">
      <i class="das das-corss fs-12 close-btn"></i>
    </button>
  </div>
  <span *ngIf="isRevokeMode" class="access-message fs-14 text-muted">{{
    'grantAccessDialog.selectGroupOrUser' | translate
  }}</span>
  <!-- Selected Documents/Folders Section -->
  <div class="selected-documents-section" *ngIf="data.selectedDocuments && data.selectedDocuments.length > 0">
    <div class="selected-documents-list">
      <div
        *ngFor="let document of data.selectedDocuments"
        class="selected-document-item d-flex justify-content-between align-items-center"
      >
        <div class="document-info d-flex align-items-center">
          <mat-icon class="document-icon" [ngClass]="document.type === 'folder' ? 'folder-icon' : 'file-icon'">
            {{ document.type === 'folder' ? 'folder' : 'description' }}
          </mat-icon>
          <span class="fs-14 text-black fw-medium">{{ document.name }}</span>
        </div>
        <button type="button" (click)="removeDocument(document)" class="remove-document-btn border-0 bg-transparent">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
  </div>
  <!-- grant access -->
  <div *ngIf="!isRevokeMode" mat-dialog-content class="dialog-content">
    <div class="access-type-section mb-2">
      <mat-radio-group [(ngModel)]="accessType" (change)="onAccessTypeChange($event.value)">
        <mat-radio-button value="group" class="me-3">{{ 'grantAccessDialog.group' | translate }}</mat-radio-button>
        <mat-radio-button value="user">{{ 'grantAccessDialog.user' | translate }}</mat-radio-button>
      </mat-radio-group>
    </div>

    <div class="dropdown-section">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>
          {{ 'grantAccessDialog.select' | translate }}
          {{
            accessType === 'group' ? ('grantAccessDialog.group' | translate) : ('grantAccessDialog.user' | translate)
          }}
        </mat-label>

        <mat-select [disabled]="loading" panelClass="grant-access-dropdown">
          <div class="search-container p-2">
            <mat-form-field appearance="outline" class="w-100 search-field">
              <mat-label>{{ 'grantAccessDialog.search' | translate }}</mat-label>
              <input matInput [(ngModel)]="searchTerm" (input)="onSearch()" />
              <mat-icon matSuffix>search</mat-icon>
            </mat-form-field>
          </div>

          <div
            class="options-container"
            *ngIf="!loading"
            (scroll)="onScroll($event)"
            style="max-height: 300px; overflow-y: auto"
          >
            <mat-option *ngFor="let item of filteredItems" [value]="item.id" class="custom-option">
              <mat-checkbox
                [checked]="isItemSelected(item)"
                (change)="toggleItemSelection(item, $event.checked)"
                (click)="$event.stopPropagation()"
              >
                {{ accessType === 'group' ? item.group_name : item.full_name }}
              </mat-checkbox>
            </mat-option>
            <div *ngIf="isLoadingMore" class="loading-more">
              <mat-spinner diameter="20"></mat-spinner>
              <span>{{ 'grantAccessDialog.loadingMore' | translate }}</span>
            </div>
          </div>

          <div *ngIf="loading" class="loading-container p-3 text-center">
            <mat-icon class="spin">refresh</mat-icon>
            <span class="ms-2">{{ 'grantAccessDialog.loading' | translate }}</span>
          </div>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="selected-items mb-3" *ngIf="selectedItems.length > 0">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <span class="access-message fs-14 text-black">{{ 'grantAccessDialog.accessWillBeGranted' | translate }}</span>
        <span class="selected-count fs-12 text-black"
          >{{ 'grantAccessDialog.selected' | translate }}
          <span class="fw-medium">
            {{ selectedGroups.length }} {{ 'grantAccessDialog.gr' | translate }}, {{ selectedUsers.length }}
            {{ 'grantAccessDialog.us' | translate }}</span
          ></span
        >
      </div>

      <div class="selected-list">
        <div *ngFor="let item of selectedItems" class="selected-item d-flex justify-content-between align-items-center">
          <div class="item-info d-flex align-items-center">
            <mat-icon class="item-icon d-flex align-items-center justify-content-center me-2">
              {{ accessType === 'group' ? 'group' : 'person' }}
            </mat-icon>
            <span class="fs-14 text-black fw-medium">{{
              accessType === 'group' ? item.group_name : item.full_name
            }}</span>
          </div>
          <button type="button" (click)="removeSelectedItem(item)" class="remove-btn">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="isRevokeMode" mat-dialog-content class="dialog-content">
    <div class="access-type-section mb-2">
      <mat-radio-group [(ngModel)]="accessType">
        <mat-radio-button value="group" class="me-3">{{ 'grantAccessDialog.group' | translate }}</mat-radio-button>
        <mat-radio-button value="user">{{ 'grantAccessDialog.user' | translate }}</mat-radio-button>
      </mat-radio-group>
    </div>

    <div class="existing-access-section mb-3" *ngIf="!loadingExistingAccess">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <span class="access-message access-message-medium fw-medium text-black">{{
          ('grantAccessDialog.accessGrantedToFollowing' | translate) + ' (' + data.selectedDocuments.length + ')'
        }}</span>
      </div>

      <div class="existing-list" *ngIf="existingItems.length > 0">
        <div *ngFor="let item of existingItems" class="existing-item d-flex align-items-center">
          <mat-checkbox
            [checked]="isItemSelected(item)"
            (change)="toggleItemSelection(item, $event.checked)"
            class="me-2"
          >
          </mat-checkbox>
          <div class="item-info d-flex align-items-center flex-grow-1">
            <mat-icon class="item-icon d-flex align-items-center justify-content-center me-2">
              {{ accessType === 'group' ? 'group' : 'person' }}
            </mat-icon>
            <span class="fs-14 text-black fw-medium">{{ accessType === 'group' ? item.name : item.name }}</span>
          </div>
        </div>
      </div>

      <div class="text-center p-3" *ngIf="existingItems.length === 0">
        <p class="text-muted mb-0">{{ 'grantAccessDialog.noAccessGranted' | translate }}</p>
      </div>
    </div>

    <div
      class="d-flex flex-column align-items-center justify-content-center"
      style="min-height: 200px"
      *ngIf="loadingExistingAccess"
    >
      <mat-spinner diameter="40"></mat-spinner>
      <p class="mt-3 text-muted">{{ 'grantAccessDialog.loadingExistingAccess' | translate }}</p>
    </div>
  </div>

  <div mat-dialog-actions class="dialog-actions">
    <button
      *ngIf="!isRevokeMode"
      class="btn rounded-1 fs-14 btn-primary fw-bold"
      (click)="onGrantAccess()"
      [disabled]="selectedItems.length === 0 || submitting"
    >
      <span *ngIf="!submitting">{{ 'grantAccessDialog.grantAccess' | translate }}</span>
      <span *ngIf="submitting"> {{ 'grantAccessDialog.granting' | translate }}</span>
    </button>
    <button
      *ngIf="isRevokeMode"
      class="btn rounded-1 fs-14 btn-primary fw-bold"
      (click)="revokeAccess()"
      [disabled]="selectedItems.length === 0 || submitting"
    >
      <span *ngIf="!submitting">{{ 'grantAccessDialog.revoke' | translate }}</span>
      <span *ngIf="submitting">{{ 'grantAccessDialog.revoking' | translate }}</span>
    </button>
    <button class="btn btn-outline-primary fw-bold fs-14 rounded-1" (click)="onCancel()" [disabled]="submitting">
      {{ 'grantAccessDialog.cancel' | translate }}
    </button>
  </div>
</div>
